
import { formatDate, getHumanizedTimeFromNow } from '@/utils/date'
import { defineComponent } from 'vue'

// types
import ActiveUserMixin from '~/mixins/activeUserMixin'
import RepoListMixin from '~/mixins/repoListMixin'
import { TeamPerms } from '~/types/permTypes'
import { Repository, RepositoryKindChoices, TeamMemberRoleChoices } from '~/types/types'

export default defineComponent({
  name: 'RecentlyActiveRepoList',
  mixins: [ActiveUserMixin, RepoListMixin],
  data() {
    return {
      repoListLoading: false,
      showAddRepoModal: false
    }
  },
  async fetch(): Promise<void> {
    this.repoListLoading = true
    const { provider, owner } = this.$route.params

    await this.fetchActiveAnalysisRepoListWithAnalyzers({
      limit: 8,
      login: this.$route.params.owner,
      provider: this.$route.params.provider
    })

    if (process.client)
      this.$localStore.set(
        `${provider}-${owner}`,
        'recently-active-repo-count',
        this.repoWithActiveAnalysisWithAnalyzers?.length ?? 0
      )
    this.repoListLoading = false
  },
  computed: {
    canActivateRepo(): boolean {
      const role = this.activeDashboardContext.role as TeamMemberRoleChoices
      return this.$gateKeeper.team(TeamPerms.ACTIVATE_ANALYSIS, role)
    },
    loaderCount(): number {
      const { provider, owner } = this.$route.params
      let localCountFromStore
      if (process.client) {
        localCountFromStore = this.$localStore.get(
          `${provider}-${owner}`,
          'recently-active-repo-count'
        ) as number
      }
      return localCountFromStore ?? 8
    }
  },
  methods: {
    getHumanizedTimeFromNow,
    formatDate,
    generateLink({ vcsProvider, ownerLogin, name }: Repository): string {
      return ['', this.$providerMetaMap[vcsProvider].shortcode, ownerLogin, name].join('/')
    },
    getIcon({ isPrivate, kind }: Repository): string {
      if (kind === RepositoryKindChoices.Subrepo) {
        return isPrivate ? 'folder-locked' : 'folder-globe'
      }

      return isPrivate ? 'z-lock' : 'globe'
    }
  }
})
